import {
    MOBILE_MENU_CLOSE,
    MOBILE_MENU_OPEN,
    MOBILE_SEARCH_CLOSE,
    MOBILE_SEARCH_OPEN,
} from './mobileMenuActionTypes';

const initialState = {
    open: false,
    searchOpen: false
};

export default function mobileMenuReducer(state = initialState, action) {
    switch (action.type) {
        case MOBILE_MENU_OPEN:
            return {
                ...state,
                open: !state.open,
            };
        case MOBILE_MENU_CLOSE:
            return {
                ...state,
                open: false,
            };
        case MOBILE_SEARCH_OPEN:
            return {
                ...state,
                searchOpen: true,
            };
        case MOBILE_SEARCH_CLOSE:
            return {
                ...state,
                searchOpen: false,
            };
        default:
            return state;
    }
}
